<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">注册</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <!-- Text inputs -->
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">姓名</div>
                <div class="item-input">
                  <input type="text" v-model.trim="customerName" placeholder="姓名">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">手机号码</div>
                <div class="item-input">
                  <input type="text" v-model.trim="Mobile" placeholder="手机号码">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">E-mail</div>
                <div class="item-input">
                  <input type="email" v-model.trim="Email" placeholder="邮箱地址">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">登录密码</div>
                <div class="item-input">
                  <input type="password" v-model.trim="Password" placeholder="登录密码">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">确认密码</div>
                <div id="password" class="item-input">
                  <input type="password" v-model.trim="rePassword" placeholder="确认密码">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">单位</div>
                <div class="item-input">
                  <input class="open-popup open-enterprise" data-popup=".popup-enterprise" type="text"
                         placeholder="单位名称" id="enterpriseName" v-model.trim="addEnterprise" readonly unselectable="on">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content" v-if="showSecondLevelEnterprise">
              <div class="item-inner">
                <div class="item-title label">二级单位</div>
                <div class="item-input">
                  <select v-model="secondLevelEnterpriseNo" name="fruit" placeholder="请选择二级单位">
                    <option v-for="va in secondLevelEnterpriseList" v-bind:value="va.enterpriseNo">{{ va.enterpriseName }}</option>
                  </select>
                </div>
              </div>
            </div>
          </li>
          <!-- Date -->
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">地址(可选)</div>
                <div class="item-input">
                  <textarea v-model.trim="Address"></textarea>
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">接收促销信息</div>
                <div class="item-input" style="margin-top: 1px;margin-left: 45%;">
                  <label class="label-switch">
                    <input type="checkbox"  v-model="isReceivePromotion">
                    <div class="checkbox"></div>
                  </label>
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">验证码</div>
                <div class="item-input">
                  <input style="width:7.4rem;display: inline;" type="text" v-model.trim="veriCode" placeholder="验证码">
                  <div style="display: inline;width: 2.5rem">
                    <a @click="register" id="btn">发送</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-100">
            <a @click="submit" v-if="disableSubmit" class="button button-big button-fill button-success">提交</a>
            <span v-else class="button button-big button-fill fill-grey">提交</span>
          </div>
        </div>
      </div>
    </div>
    <modal-register-agreement @close="showModal = false" :show.sync="showModal"></modal-register-agreement>
  </div>
</template>


<script>
  import md5 from 'js-md5'
  import $ from 'jquery'
  import EMKT from '../../../emkt.js'
  import {mapState, mapMutations} from 'vuex'
  import modalRegisterAgreement from '../../../components/ModalRegisterAgreement.vue'

  export default {
    mounted () {
      let _this = this
      $(document).on('close', function () {
        _this.addEnterprise = _this.enterpriseInfo.enterpriseName
      })
    },
    created () {
    },
    data () {
      return {
        customerName: '',
        Mobile: '',
        Email: '',
        Password: '',
        rePassword: '',
        Address: '',
        addEnterprise: '',
        isReceivePromotion: true,
        error: '出错了',
        showModal: true,
        veriCode: '',
        coolDown: false,
        disableSubmit: false,
        sendVeriCodeSuccess: false,
        secondLevelEnterpriseList: [],
        showSecondLevelEnterprise: false,
        secondLevelEnterpriseNo: null
      }
    },
    computed: {
      ...mapState([
        'enterpriseInfo'
      ])
    },
    watch: {
      'rePassword': function (val) {
        var _this = this
        if (val !== _this.Password) {
          document.getElementById('password').className = 'error item-input'
        } else {
          document.getElementById('password').className = 'item-input'
        }
      },
      'veriCode': function (val) {
        let reg = new RegExp(/^\d{6}$/)
        if (this.sendVeriCodeSuccess && reg.test(val)) {
          this.disableSubmit = true
        } else {
          this.disableSubmit = false
        }
      },
      'enterpriseInfo': function (val) {
        let _this = this
        _this.gcapi('getSecondEnterpriseInfoByFirstEnterpriseNo', _this.enterpriseInfo.enterpriseNo).then(function (response) {
          _this.secondLevelEnterpriseList = response.body.result
          _this.showSecondLevelEnterprise = true
          if (_this.addEnterprise.endsWith('医院')) {
            if (_this.secondLevelEnterpriseList.length < 1) {
              $.toast('该单位二级单位不可为空，请您联系客服处理！')
              return
            }
          } else {
            _this.showSecondLevelEnterprise = false
          }
        })
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET', 'LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'MYORDER_UPDATE'
      ]),
      sendVeriCode () {
        let _this = this
        let mobile = _this.Mobile.replace(/\s+/g, '')
        if (!_this.coolDown) {
          _this.gcapi('gcwwwifc/requestActivation', {'LoginId': mobile})
            .then((response) => {
              _this.coolDown = true
              time(document.getElementById('btn'))
              $.toast(response.body['message'])
              _this.sendVeriCodeSuccess = true
            }, (response) => {
              $.toast(response.body['message'])
            })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      checkInfo () {
        let _this = this
        if (!_this.customerName) {
          _this.error = '请填写姓名'
          return false
        }
        let mobile = _this.Mobile.replace(/\s+/g, '')
        if (!mobile) {
          _this.error = '请填写手机号'
          return false
        }
        if (!/^1[3-9]{1}[0-9]{9}$/.test(mobile)) {
          _this.error = '手机号有误'
          return false
        }
        let email = _this.Email
        if (!email) {
          _this.error = '请填写邮箱'
          return false
        }
        if (email) {
          if (!/^\w+([._-]\w+)*@(\w+\.)+\w+$/.test(email)) {
            _this.error = '邮箱有误'
            return false
          }
        }
        let pass = _this.Password
        let rePass = _this.rePassword
        if (!pass || !rePass) {
          _this.error = '请填写密码并确认密码'
          return false
        }
        if (rePass !== pass) {
          _this.error = '两次密码不同'
          return false
        }
        if (!_this.addEnterprise) {
          _this.error = '请填写单位'
          return false
        }
        if (_this.secondLevelEnterpriseNo === null && _this.showSecondLevelEnterprise) {
          _this.error = '请选择二级单位'
          return false
        }
        return true
      },
      register () {
        var _this = this
        if (_this.checkInfo()) {
          let address = _this.Address
          address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '')
          _this.gcapi('gcwwwifc/addCustomer', {
            'CustomerName': _this.customerName.replace(/\s/g, ''),
            'Mobile': _this.Mobile.replace(/\s+/g, ''),
            'Password': md5(_this.Password).toUpperCase(),
            'EnterpriseNo': _this.enterpriseInfo.enterpriseNo,
            'SecondEnterpriseNo': _this.secondLevelEnterpriseNo,
            'Email': _this.Email,
            'Address': address,
            'AddEnterprise': _this.enterpriseInfo.enterpriseName,
            'ReceivePromotion': _this.isReceivePromotion === true ? 1 : 0
          }).then((response) => {
            if (response.body.code === 0) {
              // register successful， then send validate code
//              _this.getLotteryChance()
              _this.sendVeriCode()
            } else {
              $.toast(response.body['message'])
            }
          }, (response) => {
            $.toast(response.body['message'])
          })
        } else {
          $.toast(_this.error)
        }
      },
      submit () {
        let _this = this
        _this.gcapi('gcwwwifc/activateCustomer', {'LoginId': _this.Mobile.replace(/\s+/g, ''), 'VerifyCode': _this.veriCode})
          .then((response) => {
            if (response.body.code === 0) {
              // activate customer successful ,then login
              _this.login()
            } else {
              $.toast(response.body['message'])
            }
          }, (response) => {
            $.toast(response.body['message'])
          })
      },
      saveWorkExperience (customerNo) {
        if (!customerNo) return
        // 保存任职关系
        const workExperience = {}
        workExperience.firstLevelEnterpriseNo = this.enterpriseInfo.enterpriseNo
        workExperience.customerNo = customerNo
        workExperience.startDT = new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getDate()
        workExperience.createDT = workExperience.startDT
        this.gcapi('saveWorkExperience', workExperience).then(res => {
          if (res && res.body.code === 0) {
            this.getResearchGroupInfo(customerNo)
          }
        })
      },
      login () {
        var _this = this
        if (_this.Mobile && _this.Password) {
          _this.gcapi('gcwwwifc/login', {
            'LoginId': _this.Mobile.replace(/\s+/g, ''),
            'Password': md5(_this.Password).toUpperCase()
          }).then((response) => {
            if (response.body['code'] === 0) {
              $.toast('登录成功')
              _this.LOGIN_STATE_UPDATE(true)
              if (!EMKT.isResearchGroup) {
                _this.gcapi('retrieveMyOrder').then((response) => {
                  _this.MYORDER_UPDATE(response.body.result)
                  _this.$router.push('/me')
                  _this.getLotteryChance()
                })
              }
              _this.gcapi('gcwwwifc/getCustomerInfo').then(res => {
                _this.CLIENT_INFO(res.body.result)
                let customerNo = res.body.result.customerInfo.customerNo
                let shareUrl = EMKT.wxShareUrl + '?introducer=' + customerNo
                $.sign.shareUrl = shareUrl
                // _this.saveWorkExperience(customerNo)
                EMKT.wxShare()
                _this.$router.push('/me')
              })
            } else {
              $.toast(response.body['message'])
            }
          }, (response) => {
            $.toast(response.body)
          })
        } else {
          $.toast('请输入登录信息')
        }
      },
      getResearchGroupInfo (customerNo) {
        // customerNo = EMKT.testCustomerNo
        // 获取所有的课题组信息
        this.gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(res => {
          if (res.body.result) {
            const researchGroupMemberMap = res.body.result.bResearchGroupMemberMap
            const researchGroupSet = res.body.result.bResearchGroupList
            this.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap)
            this.UPDATE_RESEARCHGROUP_SET(researchGroupSet)
            console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet)
          }
        })
        // 过滤掉无效的任职关系
        this.gcapi('getWorkExperienceList', customerNo).then(res => {
          if (res && res.body.result) {
            const workList = res.body.result.filter(work => {
              return work.enable === true
            })
            EMKT.setStoreItem('EmktWorkExperienceList', workList)
          } else {
            EMKT.setStoreItem('EmktWorkExperienceList', [])
          }
          console.log('EmktWorkExperienceList', EMKT.getLocalStorage('EmktWorkExperienceList'))
        })
      },
      getLotteryChance () {
        let _this = this
        this.gcapi('getAvailableLotteryChance', 'CustomerRegister').then((res) => {
          if (res.body.result.length > 0) {
            let url = res.body.result[0].url
            $.modal({
              text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/lottery_register.jpg"></div>',
              buttons: [{
                text: '关闭'
              }],
              onClick: function () {
                $.modal({
                  text: '亲，您确定放弃本次活动嘛～～～',
                  buttons: [{
                    text: '确定放弃'
                  }, {
                    text: '返回活动',
                    onClick: function () {
                      _this.getLotteryChance()
                    }
                  }]
                })
              }
            })
            $('#lottery').click(function () {
//              window.open('https://jinshuju.net/f/4p9nKB')
              window.open(url)
              $.closeModal()
            })
          }
        })
      }
    },
    components: {
      modalRegisterAgreement
    }
  }
</script>


<style scoped>
  .error {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .fill-grey{
    background: grey;
  }
</style>



// WEBPACK FOOTER //
// Register.vue?05da9a39